var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maptoolscontainer"},[_c('ul',_vm._l((_vm.toolsData),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.clickTool(item)}}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":item.img,"alt":""}})]),_vm._v(" "),_c('span',{staticClass:"li-span"},[_vm._v(_vm._s(item.name))])])}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71ae76e2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CultivatedLandComponent/Tools.vue
// module id = null
// module chunks = 